import { useRef } from "react";

// M10-15867: for an Autocomplete `asyncListFunction` whose backing API has no real pagination
// (it always returns the same full list). Autocomplete calls asyncListFunction() with no args on
// initial/refresh fetches, but always passes a page number on infinite-scroll "load more" calls —
// caches the result per cacheKeyParts and short-circuits those load-more calls to an empty list,
// so scrolling to the end stops instead of re-fetching/duplicating the same data.
const useSingleFetchAutocomplete = (fetchList: () => Promise<any>, cacheKeyParts: any[]) => {
  const cacheRef = useRef<{ key: string; result: any } | null>(null);

  return (_query?: string, page?: number) => {
    if (page !== undefined) {
      return Promise.resolve({ data: { data: [] } });
    }
    const cacheKey = JSON.stringify(cacheKeyParts);
    if (cacheRef.current?.key === cacheKey) {
      return Promise.resolve(cacheRef.current.result);
    }
    return fetchList().then((res) => {
      cacheRef.current = { key: cacheKey, result: res };
      return res;
    });
  };
};

export default useSingleFetchAutocomplete;